// extracted by mini-css-extract-plugin
module.exports = {"container":"_2YazBai6Eruo4enPeyXfX1"};